import { render, staticRenderFns } from "./Recursos.vue?vue&type=template&id=58742452&scoped=true&"
import script from "./Recursos.vue?vue&type=script&lang=js&"
export * from "./Recursos.vue?vue&type=script&lang=js&"
import style0 from "./Recursos.vue?vue&type=style&index=0&id=58742452&lang=scss&scoped=true&"
import style1 from "@/styles/manifestacao.scss?vue&type=style&index=1&id=58742452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58742452",
  null
  
)

export default component.exports